import { useGetApi } from "src/hooks";
import { getYachtId } from "src/utils";

interface IVesselLogoResponse {
  logo?: { data: string; updateddate?: string };
}

const mapVesselLogo = (data: IVesselLogoResponse): string =>
  data?.logo?.data ? `data:image/png;base64,${data.logo.data}` : "";

// Each mounted surface fetches independently, matching the Ships Stamps pattern.
export const useVesselLogo = () => {
  const { data, isLoading, refetch } = useGetApi<string>({
    request: "get-vessel-logo",
    body: { params: { yachtid: getYachtId() } },
    mapper: mapVesselLogo,
  });

  return { logo: data ?? "", isLoading, refetch };
};
